import { render, staticRenderFns } from "./ProvisioningConfigInput.vue?vue&type=template&id=5f23fc47"
import script from "./ProvisioningConfigInput.vue?vue&type=script&lang=js"
export * from "./ProvisioningConfigInput.vue?vue&type=script&lang=js"
import style0 from "./ProvisioningConfigInput.vue?vue&type=style&index=0&id=5f23fc47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports